// src/components/auth/ForgotPasswordPage.js

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import { Mail, ArrowLeft } from 'lucide-react';

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        setError('');

        try {
            const response = await api.post('/auth/forgot-password', { email });
            setMessage(response.data.message);
        } catch (err) {
            console.error('Forgot password error:', err);
            setError(err.response?.data?.message || 'Failed to send reset link. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen w-full flex items-center justify-center bg-gray-900 p-4 overflow-hidden">
            <div className="absolute inset-0 z-0">
                <div className="area" style={{ background: "linear-gradient(135deg,#0b1730 0%,#12306b 55%,#0e7490 100%)" }}>
                    <ul className="circles">
                        <li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li>
                    </ul>
                </div>
            </div>
            <div className="relative z-10 bg-white/10 backdrop-blur-md p-8 sm:p-10 rounded-2xl shadow-2xl border border-white/20 w-full max-w-md">
                <div className="flex justify-center mb-8">
                     <img src="frontpagelogo.png" alt="Company Logo" className="w-24 h-24 bg-transparent" />
                </div>
                <h2 className="text-3xl font-extrabold text-center text-white mb-2">Forgot Password</h2>
                <p className="text-center text-gray-300 mb-8">Enter your email to receive a reset link.</p>


                {message && (
                    <div className="bg-green-500/30 border border-green-500 text-white px-4 py-3 rounded-lg mb-6 text-sm" role="alert">
                        {message}
                    </div>
                )}
                {error && (
                    <div className="bg-red-500/30 border border-red-500 text-white px-4 py-3 rounded-lg mb-6 text-sm" role="alert">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="email" className="sr-only">
                            Email address
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <Mail className="h-5 w-5 text-gray-400" />
                            </div>
                            <input
                                type="email"
                                id="email"
                                className="appearance-none relative block w-full pl-10 pr-4 py-3 bg-gray-800/50 border border-white/20 rounded-md shadow-sm placeholder-gray-400 text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-900 focus:ring-sky-500 sm:text-sm transition duration-150 ease-in-out"
                                placeholder="you@example.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                    </div>
                    <button
                        type="submit"
                        className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-semibold rounded-md text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-900 focus:ring-sky-500 transition duration-150 ease-in-out disabled:opacity-60 disabled:cursor-not-allowed"
                        disabled={loading}
                    >
                        {loading ? 'Sending...' : 'Send Reset Link'}
                    </button>
                </form>

                <p className="mt-8 text-center text-sm text-gray-400">
                    <Link to="/login" className="font-medium text-sky-400 hover:text-sky-300 transition duration-150 ease-in-out inline-flex items-center">
                       <ArrowLeft className="h-4 w-4 mr-2" /> Back to Login
                    </Link>
                </p>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
